// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateLandlordDTO
 */
export interface UpdateLandlordDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    type?: UpdateLandlordDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordDTO
     */
    contactNumber?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateLandlordDTOTypeEnum {
    COMPANY = 'COMPANY',
    SOLEPERSON = 'SOLE_PERSON'
}



